import global from "@/locales/de-AT/global";
import error403 from "@/locales/de-AT/errors/403";
import error404 from "@/locales/de-AT/errors/404";
import error500 from "@/locales/de-AT/errors/500";
import error503 from "@/locales/de-AT/errors/503";
import error504 from "@/locales/de-AT/errors/504";
import maintenance from "@/locales/de-AT/auth/maintenance";
import toast from "@/locales/de-AT/toast/toast";
import login from "@/locales/de-AT/auth/login";
import onboarding from "@/locales/de-AT/auth/onboarding";
import loginPageSteps from "@/locales/de-AT/loginPageSteps";
import dashboard from "@/locales/de-AT/dashboard/dashboard";
import account from "@/locales/de-AT/account/account";
import mailbox from "@/locales/de-AT/account/mailbox";
import bankstatement from "@/locales/de-AT/account/bankstatement";
import myApps from "@/locales/de-AT/my-apps/myApps";
import about from "@/locales/de-AT/about/about";
import contactService from "@/locales/de-AT/about/contactService";
import salesPromotions from "@/locales/de-AT/sales/promotions";
import brochures from "@/locales/de-AT/sales/brochures";
import shop from "@/locales/de-AT/shop/data";
import priceList from "@/locales/de-AT/shop/priceList";
import staff from "@/locales/de-AT/dashboard/staff";
import promotions from "@/locales/de-AT/promotions";
import points from "@/locales/de-AT/points";
import trainings from "@/locales/de-AT/trainings/trainings";
import vouchers from "@/locales/de-AT/vouchers/vouchers";
import generateReport from "@/locales/de-AT/generate-report/generateReport";
import widgets from "@/locales/de-AT/widgets/widgets";
import wholesaler from "@/locales/de-AT/wholesaler/wholesaler";
import media from "@/locales/de-AT/media/index";
import onlineVisibility from "@/locales/de-AT/sales/onlineVisibility";
import fuelCalculator from "@/locales/de-AT/sales/fuelCalculator";
import product from "@/locales/de-AT/product/index";
import message from "@/locales/de-AT/message/index";
import commitmentLetter from "@/locales/de-AT/account/commitmentLetter";
import multiplicator from "@/locales/de-AT/multiplicator";
import consents from "@/locales/de-AT/consents/consents";
import investment from "@/locales/de-AT/investment/data";
import publicCountryNotice from "@/locales/de-AT/publicCountryNotice";
import kickback from "@/locales/de-AT/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  publicCountryNotice: publicCountryNotice.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  onlineVisibility: onlineVisibility.messages,
  priceList: priceList.messages,
  fuelCalculator: fuelCalculator.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produkt-Abbildungen",
    BDriveLinkText: "Link zum PRODUKT-ABBILDUNGEN Portal",
  },
}

export default {
  locale: "de-AT",
  messages,
};
